export const SET_CAMBIOESTIMACIONVERSION = "SET_CAMBIOESTIMACIONVERSION";
export const CREATE_CAMBIOESTIMACIONVERSION = "CREATE_CAMBIOESTIMACIONVERSION";
export const CAMBIOESTIMACIONVERSIONS_RECEIVED =
  "CAMBIOESTIMACIONVERSIONS_RECEIVED";
export const SET_PROPERTY_CAMBIOESTIMACIONVERSION =
  "SET_PROPERTY_CAMBIOESTIMACIONVERSION";
